import './scss/main.scss';

import { createApp } from 'vue';
import * as Sentry from '@sentry/vue';
import App from './App.vue';
import i18n from './i18n';
import { createVuestic } from 'vuestic-ui';
import { createGtm } from '@gtm-support/vue-gtm';

import stores from './stores';
import router from './router';
import vuesticGlobalConfig from './services/vuestic-ui/global-config';
import { keepPreviousData, QueryClient, VueQueryPlugin } from '@tanstack/vue-query';

const app = createApp(App);

Sentry.init({
  app,
  dsn: 'https://a59d98cbd9d505d03d793520ead9b33c@sentry.pocket.company/12',
  environment: import.meta.env.MODE,
  release: import.meta.env.VITE_APP_BUILD_VERSION || undefined,
  integrations: [
    Sentry.browserTracingIntegration({ router, routeLabel: 'name' }),
    Sentry.captureConsoleIntegration({ levels: ['error'] }),
  ],
  attachProps: false,
  dataCollection: {
    userInfo: false,
    cookies: false,
    httpHeaders: { request: false, response: false },
    httpBodies: [],
    urlQueryParams: false,
    stackFrameVariables: false,
  },
  beforeSend(event) {
    if (event.logger === 'console' && event.extra) {
      delete event.extra.arguments;
    }
    return event;
  },
});

app.use(stores);
app.use(router);
app.use(i18n);
app.use(createVuestic({ config: vuesticGlobalConfig }));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { placeholderData: keepPreviousData, refetchOnReconnect: false, refetchOnWindowFocus: false },
  },
});

app.use(VueQueryPlugin, { queryClient });

if (import.meta.env.VITE_APP_GTM_ENABLED) {
  app.use(
    createGtm({
      id: import.meta.env.VITE_APP_GTM_KEY,
      debug: false,
      vueRouter: router,
    }),
  );
}

app.mount('#app');
